import React from 'react';
import { Modal } from 'react-bootstrap';
import logo from '../../static/images/logo-countpicula-dark.png';
import iconTip from '../../static/images/icon-tip.svg';

const ModalView = ({
  id,
  title,
  body,
  footer,
  show,
  close,
  footerTip,
  extraFooter = null
}) => {
  let footerClass = 'modal-footer';
  if (footerTip) {
    footerClass = 'modal-footer modal-footer--tip';
  }
  return (
    <Modal show={show} onHide={close} bsSize="large">
      <Modal.Header closeButton>
        <div>
          <h2 className="modal-title" id={id}>
            <span>{title}</span>
          </h2>
          <img className="logo-img" src={logo} width="117" height="75" alt="" />
        </div>
      </Modal.Header>
      <div className="modal-body">{body}</div>
      <div className={footerClass}>
        <div>
          {footerTip && (
            <img className="tip-icon" src={iconTip} width="310" alt="" />
          )}
          {footer}
        </div>
      </div>
      {extraFooter}
    </Modal>
  );
};

export default ModalView;



// WEBPACK FOOTER //
// ./src/comps/Feature/ModalView.js